module.exports = __webpack_public_path__ + "img/programme1.d48d35e4.png";